import * as React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import { InfoGraphics } from '@/components/AuthV2/InfoGraphics';
import { InfoText } from '@/components/AuthV2/InfoText';
import { Navbar } from '@/components/AuthV2/Navbar';
import { Column, Container, Row } from '@/components/AuthV2/wrappers';
import { ErrorBoundary as ErrorBoundaryImpl } from '@/components/ErrorBoundaries/ErrorBoundary';
import { LazyLoadingFallback } from '@/components/Loaders/LazyLoadingFallback';
import { useResponsiveConstants } from '@/hooks/responsive/useResponsiveConstants';
import { AUTH_ROUTES, OAUTH_ROUTES } from '@/nav-routes';
import AuthComponentV2 from '@/routes/AuthV2';
import OAuthCallbackHandlerV2 from '@/routes/OAuthCallbackV2';
import { AuthRoute } from '@/utils/AuthRoute';

const AuthRoutesV2 = () => {
  const { desktopAndBelow } = useResponsiveConstants();
  const match = useRouteMatch('/oauth/redirect');
  const hideValueProp = desktopAndBelow && match;

  React.useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-PJ6P3NM');
      `;

    document.body.appendChild(script);
  }, []);

  const appType = localStorage.getItem('appType');

  return (
    <Container>
      {appType ? null : <Navbar />}
      <Row>
        {hideValueProp || appType ? null : (
          <Column>{desktopAndBelow ? <InfoText /> : <InfoGraphics />}</Column>
        )}
        <Column>
          <Switch>
            <Route path={OAUTH_ROUTES.REDIRECT}>
              <ErrorBoundary FallbackComponent={ErrorBoundaryImpl}>
                <React.Suspense fallback={<LazyLoadingFallback />}>
                  <OAuthCallbackHandlerV2 />
                </React.Suspense>
              </ErrorBoundary>
            </Route>
            <AuthRoute path={AUTH_ROUTES.BASE_ROUTE}>
              <ErrorBoundary FallbackComponent={ErrorBoundaryImpl}>
                <React.Suspense fallback={<LazyLoadingFallback />}>
                  <AuthComponentV2 />
                </React.Suspense>
              </ErrorBoundary>
            </AuthRoute>
          </Switch>
        </Column>
      </Row>
    </Container>
  );
};

export default AuthRoutesV2;
